// @flow

import type {Dispute, Features, PaymentMethod} from '../../containers/disputes/types';
import type {RawDispute, RawDisputeFeatures, RawPaymentMethod} from './types';

const formatName = (str: string): string => {
  const name = str.replace(/_/g, ' ').toLowerCase();

  return name ? name.charAt(0).toUpperCase() + name.slice(1) : '';
};

export const convertPaymentMethod = (raw: RawPaymentMethod): PaymentMethod => ({
  paymentMethod: raw.payment_method,
  reasons: raw.reasons.map(reason => ({
    id: reason.id,
    name: reason.name && formatName(reason.name)
  })),
  instances: (raw.instances || []).map(instance => ({
    id: instance.id,
    name: instance.name
  }))
});

export const convertDispute = (raw: RawDispute): Dispute => ({
  id: raw.id,
  paymentMethod: raw.payment_method,
  instance: raw.instance,
  transaction: {
    id: raw.transaction.id,
    date: raw.transaction.invoice_time,
    amount: raw.transaction.amount,
    countryCode: raw.transaction.country_code,
    status: raw.transaction.status_id
  },
  projectID: raw.project_id,
  incomingDate: raw.date.incoming,
  user: raw.user,
  reason: {
    id: raw.reason.id,
    name: raw.reason.name && formatName(raw.reason.name)
  },
  status: {
    id: raw.status.id,
    name: raw.status.name && formatName(raw.status.name)
  },
  result: raw.result.id,
  type: {
    id: raw.type.id,
    name: raw.type.name && formatName(raw.type.name)
  },
  description: raw.description,
  fee: raw.fee,
  isFinal: raw.is_final,
  partner_evidence_status: raw.partner_evidence_status
});

export const convertDisputeFeature = (raw: RawDisputeFeatures): Features => {
  const features: Features = [];

  Object.keys(raw).forEach(key => {
    features.push({
      name: key,
      enabled: raw[key].enabled
    });
  });

  return features;
};
